import {
  MemoizedSelector,
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';
import { State, tagFeatureKey } from '../reducers/tag.reducer';
import {
  GroupTagState,
  selectAllGroupTagsAdapter,
} from '../entity/group-tag.entity';
import { GroupTag } from '@sleipai/sleip-models';
import { filter } from 'lodash';

export const selectTagState: MemoizedSelector<object, State> =
  createFeatureSelector<State>(tagFeatureKey);

export const isLoading = (state: State): boolean => state.loading;
export const isLoaded = (state: State): boolean => state.loaded;

export const groupTagsState = (state: State): GroupTagState => state.groupTags;

const selectGroupTagState = createSelector(selectTagState, groupTagsState);

export const selectAllGroupTags: (state: State) => GroupTag[] = createSelector(
  selectGroupTagState,
  selectAllGroupTagsAdapter
);

export const selectGroupTagsByGroupId = (groupId: string) =>
  createSelector(selectAllGroupTags, (groupTagItems: GroupTag[]) => {
    if (groupTagItems && groupId) {
      const filteredGroupTagsByGroupId = filter(
        groupTagItems,
        (tag) => tag.groupId === groupId
      );
      return filteredGroupTagsByGroupId;
    } else {
      return [];
    }
  });

export const selectGroupTagByTagId = (groupTagId: string) =>
  createSelector(selectAllGroupTags, (groupTagItems: GroupTag[]) => {
    if (groupTagItems && groupTagId) {
      return (
        groupTagItems.find((groupTag) => groupTag.id === groupTagId) ?? null
      );
    } else {
      return null;
    }
  });
